// import ColVisibilitySelector from "components/DataTable/ColVisibilitySelector";
import ItemActionsMenu from "components/DataTable/ItemActionsMenu";
import React from "react";
import Checkbox from "components/Checkbox/Checkbox";
import moment from 'moment';

export default {
    TABLE: {
        className: "data-table-alerts",
        initialSortKey: "alerted_on",
        initialSortOrder: "desc"
    },

    COLUMN: [
        {
            label: "Row Selector",
            key: "row-selector",
            header: ({ customTableProps }) => {
                const isSelectedAll =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.rowsData &&
                    customTableProps.rowsData.length &&
                    customTableProps.selectedRows.length ===
                        customTableProps.rowsData.length
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelectedAll}
                        onChange={() => customTableProps.doSelectAll()}
                        name="row-selector"
                    />
                );
            },
            className: "col-row-selector",
            format: ({ rowData, customTableProps }) => {
                const isSelected =
                    customTableProps.selectedRows &&
                    customTableProps.selectedRows.length &&
                    customTableProps.selectedRows.includes(rowData)
                        ? true
                        : false;
                return (
                    <Checkbox
                        checked={isSelected}
                        onChange={() => customTableProps.onRowSelect({ rowData })}
                        name="row-selector"
                    />
                );
            },
            canBeHidden: false
        },
        {
            label: "Alert",
            header: "ALERT",
            key: "alert",
            sortable: true,
            className: "alert",
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData["alert"]}</span>;
            }
        },
        {
            label: "Alerted",
            header: "DATE ALERTED",
            key: "alerted_on",
            sortable: true,
            className: "alerted",
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData['alerted_on'] ? moment(rowData['alerted_on']).format('MM/DD/YYYY') : ''}</span>;
            }
        },
        {
            label: "Read",
            header: "READ",
            key: "status",
            sortable: true,
            className: "read",
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData["status"]}</span>;
            }
        },
        {
            label: "Site",
            header: "SITE",
            key: "siteName",
            sortable: true,
            className: "site",
            format: ({ rowData, customTableProps }) => {
                return <span>{rowData.siteName}</span>;
            }
        },
        {
            label: "Actions",
            key: "actions",
            format: ({ rowData, customTableProps }) => {
                return (
                    <ItemActionsMenu
                        actions={(() => {
                            return [
                                {
                                    label: "Notify",
                                    action: () => {
                                        customTableProps.handleNotify(rowData.id);
                                    }
                                },
                                {
                                    label: "Mark As Read",
                                    action: () => {
                                        customTableProps.handleMarkRead(rowData.id);
                                    }
                                }
                            ];
                        })()}
                    />
                );
            },
            // className: "col-actions",
            // header: ({ customTableProps }) => {
            //     return (
            //         <ColVisibilitySelector
            //             colDefs={customTableProps.colDefs}
            //             visibleColumnKeys={customTableProps.visibleColumnKeys}
            //             onChangeVisibility={colKey =>
            //                 customTableProps.onChangeVisibility(colKey)
            //             }
            //         />
            //     );
            // }
        }
    ]
};
